import * as React from 'react';
import { useDispatch } from 'react-redux';

import { openFullscreenGallery } from '../../actions/fullscreenGallery';
import { GalleryImageItem } from '../../components/GalleryImageItem';
import { trackMorePhotosByDateClick } from '../../utils/analytics';
import { IConstructionProgressImage } from '../../types/constructionProgress';
import { TThunkDispatch } from '../../types/redux';
import { MAX_GALLERY_IMAGES_LENGTH } from '../../constants/gallery';

export interface IImageItemContainerProps {
  image: IConstructionProgressImage;
  dateIndex: number;
  index: number;
  hasMoreImages: boolean;
}

export const ImageItemContainer: React.FC<IImageItemContainerProps> = props => {
  const { image, dateIndex, index, hasMoreImages } = props;
  const lastImage = index === MAX_GALLERY_IMAGES_LENGTH - 1;
  const dispatch: TThunkDispatch = useDispatch();
  const handleClick = React.useCallback(
    (slideIndex: number, dateSlideIndex: number) => {
      trackMorePhotosByDateClick();
      dispatch(openFullscreenGallery({ slideIndex, dateSlideIndex }));
    },
    [dispatch],
  );

  return (
    <GalleryImageItem
      image={image}
      dateIndex={dateIndex}
      index={index}
      onClick={handleClick}
      overlay={lastImage && hasMoreImages}
    />
  );
};
